module.exports = __webpack_public_path__ + "img/goin1.e849e24a.png";